export const prerender = true;
const PROD_URL = 'https://davidoff-immo.up.railway.app';
/** @type {import('./$types').PageLoad} */

export async function load({ fetch }) {
	try {
		let impressum = await fetch(PROD_URL + '/api/impressums?populate[ImpressumTable][populate]=*');
		let impressumData = await impressum.json();
		let backgroundImg = await fetch(PROD_URL + '/api/parallaxes?populate=*');
		let backgroundImgData = await backgroundImg.json();

		return {
			fetchedValues: {
				backgroundImg: backgroundImgData.data[0].attributes.FullScreenPicture.data.attributes.url,
				impressum: impressumData.data[0].attributes.ImpressumTable
			}
		};
	} catch (err) {
		console.log(err);
	}
}